let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hy7F8")).then(() => parcelRequire('lR9WO'));